import { functions } from '../../../config/firebase';
import { httpsCallable } from 'firebase/functions';

export async function generateThingImageByJSON(artStyle, jsonString, bookId = null, objectId = null) {
  const callable = httpsCallable(functions, 'generateThingImageByJSON', { timeout: 10000 });
  const resp = await callable({ artStyle, jsonString, bookId, objectId });
  return (resp && resp.data) || {};
}
